import React, { FC } from 'react'
import { i18n, PaletteNames } from 'LibNeo'
import { Status, StatusIcon, StatusTitle, Icon } from './styled'

export type colorStatus = PaletteNames | 'violet' | 'magenta'

export interface StatusComponentProps {
	title?: string | null
	color?: colorStatus
	iconName?: string
	isForm?: boolean
	className?: string
}

export const StatusComponent: FC<StatusComponentProps> = ({
	title = null,
	color = 'gray',
	iconName,
	isForm,
	className,
}): JSX.Element => {
	return (
		<Status
			color={color}
			isRounded={color === 'violet' || color === 'magenta'}
			isForm={isForm}
			title={title}
			className={className}
		>
			{iconName && (
				<StatusIcon color={color}>
					<Icon name={iconName} color={color} />
				</StatusIcon>
			)}
			<StatusTitle>{i18n(title)}</StatusTitle>
		</Status>
	)
}
